// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"donationList_scrollbar__1pPQT"};